module.exports = __webpack_public_path__ + "static/media/pict.35235978.png";